export default __webpack_public_path__ + "static/Montserrat-Thin-4a799b111f608dbf4f89064d71292589.ttf";